import {Component, ViewChild} from "@angular/core";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";
import {EntityData, field, identifier, ReportModel} from "@fedeltapointofsale/data-client";
import {EmployeeSearchPageComponent} from "../employee-search-page/employee-search-page.component";

export class EmployeeReportSelectionData extends EntityData<EmployeeReportSelectionData> {
    @identifier employeeId: number;
    @field userId: string;
    @field firstName: string;
    @field lastName: string;
}

@Component({
    selector: "wbo-employee-report-selection",
    templateUrl: "./employee-report-selection-control.component.html"
})
export class EmployeeReportSelectionControlComponent {

    EmployeeSearchPageComponent = EmployeeSearchPageComponent;

    fieldName: string = "employees";

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    constructor(public model: ReportModel<any>) {
    }

    addFromEmployee(data: any[]): void {
        data.forEach((item) => {
            if (!this.model.data[this.fieldName].find((employee: any) => employee.employeeId === item.employeeId)) {
                const index: number = this.editGridComponent.addRow(item) - 1;
            }
        });
    }
}
